import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import ClaimCoverSelect from '../../../../components/FNOL/ClaimCoverSelect';
import { setIncidentEvent } from '../../../../actions/claimSubmitActions';
import './KPDropdown.css';
import { IDropdown } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';

class KPDropdown extends React.Component<IDropdown, any>  {
    constructor(props) {
        super(props);
        this.state = {
            dropdownToggle: false,
            dataList: this.props.data,
        };
        this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
        this.handleItemSelection = this.handleItemSelection.bind(this);
    }

    async handleDropdownToggle(e: any) {
        await this.setState({
            dropdownToggle: !this.state.dropdownToggle
        });
    }

    async handleItemSelection(e: any) {
        this.props.handleSelection(e)
    }

    public render() {
        let defaultPlaceHolderImageDropdown = "Choose an item";
        let defaultPlaceHolderListDropdown = "Choose an item";
        let dropdownClass = ""
        if (this.props.isImageDropdown) {
            dropdownClass = "col-12 nopa ssp-dynamic-dropdown-type-plain-selector-holder"
        }
        else {
            dropdownClass = "fnol-incident-type-selector-holder"
        }
        if (this.props.isBordered) {
            dropdownClass += " ssp-dropdown-formcontrol";
        }
        if (this.props.className !== undefined) {
            if (this.props.className) {
                dropdownClass = dropdownClass + " " + this.props.className
            }
        }

        // Simple dropdown data
        var simpleDropdownData;
        if (this.props.data[0] && (this.props.data[0].image === undefined || this.props.data[0].image === '')) {

            simpleDropdownData = this.props.data.map((item) => {
                return <>
                    <Dropdown.Item eventKey={item.id} key={item.id} value={item.id}>
                        {item.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        // Image dropdown data
        var imageDropdownData;

        if (this.props.isImageDropdown && this.props.data[0] && (this.props.data[0].image !== undefined || (this.props.data[0] && this.props.data[0].image !== ''))) {
            imageDropdownData = this.props.data
                .map((item) => {
                    return <Dropdown.Item eventKey={item.id} key={item.id} value={item.id}>
                        <ClaimCoverSelect id={item.id} alertCount="0"
                            headerText={item.productName}
                            bodyText={item.description}
                            image={item.image}
                        />
                        <hr className="cover-divider" />
                    </Dropdown.Item>
                });
        }

        // Dropdown without image - Plain dropdown
        let simpleDropdown = <>
            <div className="col-12 nopa">
                {!this.props.isImageDropdown &&
                    <div className={dropdownClass}>
                        {this.props.showLabelOutside === true &&
                            <>
                                <div className="row ssp-dropdown-select-row-outside">
                                    <div className="col">
                                        <span className="ssp-dropdown-select-choose-text-selected-product">
                                            {/*/// Displays label before / outside dropdown ///*/}
                                    {this.props.showLabelAfterSelection === true && this.props.showLabelOutside === true && this.props.showLabelInside !== true && this.props.selectedValue &&
                                                <>

                                                    {this.props.label && this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.labelAfterSelection}
                                                        </>
                                                    }
                                                    {!this.props.label && this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.labelAfterSelection}
                                                        </>
                                                    }
                                                    {this.props.label && !this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.label}
                                                        </>
                                                    }
                                                    {!this.props.label && !this.props.labelAfterSelection &&
                                                        <>
                                                            {defaultPlaceHolderListDropdown}
                                                        </>
                                                    }

                                                </>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </>
                        }
                    <Dropdown id={this.props.id} className="ssp-dropdown ssp-dropdown-item-list-no-images"
                        onSelect={(e) => this.handleItemSelection(e)}
                        onToggle={this.handleDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                {this.props.selectedValue &&
                                    <>
                                        <div className="row ssp-dropdown-select-row">
                                            <div className="col">
                                                {/*/// Displays label inside dropdown area ///*/}
                                                {this.props.showLabelAfterSelection === true && this.props.showLabelInside === true && this.props.showLabelAfterSelection === true && this.props.showLabelOutside !== true &&
                                                    <>
                                                        <span className="ssp-dropdown-select-choose-text-selected-product">
                                                            {this.props.label && this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.labelAfterSelection}
                                                                </>
                                                            }
                                                            {!this.props.label && this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.labelAfterSelection}
                                                                </>
                                                            }
                                                            {this.props.label && !this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.label}
                                                                </>
                                                            }
                                                            {!this.props.label && !this.props.labelAfterSelection &&
                                                                <>
                                                                    {defaultPlaceHolderListDropdown}
                                                                </>
                                                            }
                                                        </span>
                                                    </>
                                                }
                                                <span className="ssp-dropdown-select-selected-product">{this.props.selectedValue.description === undefined ? this.props.selectedValue : this.props.selectedValue.description}</span>
                                            </div>
                                            <div className="ssp-dropdown-icon"></div>
                                        </div>
                                    </>
                                }
                                {!this.props.selectedValue &&
                                    <div className="row ssp-dropdown-select-row">
                                        <div className="col ssp-dropdown-select-choose-text-no-product">
                                            {this.props.label &&
                                                <>
                                                    {this.props.label}
                                                </>
                                            }
                                            {!this.props.label &&
                                                <>
                                                    {defaultPlaceHolderListDropdown}
                                                </>
                                            }
                                        </div>
                                        <div className="ssp-dropdown-icon"></div>
                                    </div>
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu title={this.props.title}>
                                {simpleDropdownData}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                }
            </div>
        </>

        //Dropdown with image - Extended dropdown

        let imageDropdown = <>
            {this.props.isImageDropdown &&
                <div className={dropdownClass}>
                    <>
                        {Object.keys(this.props.selectedValue).length !== 0 &&
                            <>
                                {/*/// Displays label outside dropdown area ///*/}
                                {this.props.showLabelAfterSelection === true && this.props.showLabelOutside === true && this.props.showLabelInside !== true &&
                                    <>
                                        <div className="row ssp-dropdown-select-row-outside">
                                            <div className="col">
                                                <span className="ssp-dropdown-select-choose-text-selected-product">
                                                    {this.props.label && this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.labelAfterSelection}
                                                        </>
                                                    }
                                                    {!this.props.label && this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.labelAfterSelection}
                                                        </>
                                                    }
                                                    {this.props.label && !this.props.labelAfterSelection &&
                                                        <>
                                                            {this.props.label}
                                                        </>
                                                    }
                                                    {!this.props.label && !this.props.labelAfterSelection &&
                                                        <>
                                                            {defaultPlaceHolderImageDropdown}
                                                        </>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        }
                    </>
                    <Dropdown id={this.props.id} className="ssp-dropdown"
                        onSelect={(e) => this.handleItemSelection(e)}
                        onToggle={this.handleDropdownToggle}>
                    <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button" disabled={this.state.disableDropdown}>
                            <>
                                {Object.keys(this.props.selectedValue).length !== 0 &&
                                    <>
                                        <div className="row ssp-dropdown-select-row">
                                            <div className="col">
                                                {/*/// Displays label inside dropdown area ///*/}
                                                {this.props.showLabelAfterSelection === true && this.props.showLabelInside === true && this.props.showLabelOutside !== true &&
                                                    <>
                                                        <span className="ssp-dropdown-select-choose-text-selected-product">
                                                            {this.props.label && this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.labelAfterSelection}
                                                                </>
                                                            }
                                                            {!this.props.label && this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.labelAfterSelection}
                                                                </>
                                                            }
                                                            {this.props.label && !this.props.labelAfterSelection &&
                                                                <>
                                                                    {this.props.label}
                                                                </>
                                                            }
                                                            {!this.props.label && !this.props.labelAfterSelection &&
                                                                <>
                                                                    {defaultPlaceHolderImageDropdown}
                                                                </>
                                                            }
                                                        </span>
                                                    </>
                                                }
                                                <span className="ssp-dropdown-select-selected-product">{this.props.selectedValue.description}</span>
                                            </div>
                                            <div className="ssp-dropdown-icon"></div>
                                        </div>
                                    </>
                                }
                                {!this.props.selectedValue &&
                                    <>
                                        <div className="row ssp-dropdown-select-row">
                                            <div className="col ssp-dropdown-select-choose-text-no-product">
                                                {this.props.label &&
                                                    <>
                                                        {this.props.label}
                                                    </>
                                                }
                                                {!this.props.label &&
                                                    <>
                                                        {defaultPlaceHolderImageDropdown}
                                                    </>
                                                }
                                            </div>
                                            <div className="ssp-dropdown-icon"></div>
                                        </div>
                                    </>
                                }
                            </>
                        </Dropdown.Toggle>
                        <Dropdown.Menu title={this.props.title} id="nav-dropdown">
                            {imageDropdownData}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            }
        </>
        if (this.props.isImageDropdown && this.props.data[0] && this.props.data[0].image) {
            return (
                <>
                    {imageDropdown}
                </>
            )
        } else {
            return (
                <>
                    {simpleDropdown}
                </>
            )
        }
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetIncidentEvent: (event) => dispatch(setIncidentEvent(event)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KPDropdown)